import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigServiceModel } from '@app/origami-api/services/config.service';
import {
  ModernSectionComponent,
  SectionState,
} from '@app/shared/layout/modern-section/modern-section-group/modern-section/modern-section.component';
import {
  PortletComponent,
  PortletTemplateContentDirective,
  PortletTemplateHeaderDirective,
} from '@tpt/common/layout/portlets';
import { OverflowTooltipDirective } from '@tpt/common/tooltips/overflow';
import { CardComponent } from '@app/shared/ui/card/card.component';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import {
  SectionMetadata,
  SectionMetadataComponent,
} from '@app/shared/forms/dynamic-form/dynamic-form/dynamic-form-section/section-metadata/section-metadata.component';
import FormSectionAppearance = ConfigServiceModel.FormSectionAppearance;

@Component({
  selector: 'ti-dynamic-form-section',
  standalone: true,
  imports: [
    ModernSectionComponent,
    PortletComponent,
    PortletTemplateHeaderDirective,
    PortletTemplateContentDirective,
    OverflowTooltipDirective,
    CardComponent,
    NgTemplateOutlet,
    NgIf,
    SectionMetadataComponent,
  ],
  templateUrl: './dynamic-form-section.component.html',
  styleUrl: './dynamic-form-section.component.scss',
})
export class DynamicFormSectionComponent {
  FormSectionAppearance = FormSectionAppearance;

  @Input()
  title: string = '';

  @Input()
  isStandalone: boolean = false;

  @Input()
  state: SectionState = 'default';

  @Input()
  collapsed: boolean = false;

  @Input()
  appearance: FormSectionAppearance = FormSectionAppearance.Accordion;

  @Input()
  metadata: SectionMetadata = null;

  @Output()
  collapsedChange = new EventEmitter<boolean>();

  handleCollapsedChange(collapsed: boolean) {
    this.collapsed = collapsed;
    this.collapsedChange.emit(collapsed);
  }
}
